import { render } from "./Companies.vue?vue&type=template&id=2f8e2bd4&scoped=true&ts=true"
import script from "./Companies.vue?vue&type=script&lang=ts"
export * from "./Companies.vue?vue&type=script&lang=ts"

import "./Companies.vue?vue&type=style&index=0&id=2f8e2bd4&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8e2bd4"]])

export default __exports__